import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

export const Container = styled.div<{ success?: boolean }>`
	width: 100%;
	max-height: 280px;
	height: ${({ success }) => (success ? '180px' : '280px')};
	margin-top: 50px;
	color: ${tokens.color_gray_dark};

	.submit-button {
		margin-top: 16px;
	}

	button {
		height: 36px;

		label {
			cursor: pointer;
		}
	}
`;

export const WrapperRecoverPassword = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	margin-top: 0.5rem;

	a {
		text-decoration: none;
		color: #707070;
		font-size: 1rem;
	}

	a:hover {
		color: #464646;
	}
`;

export const Description = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 16px;

	p {
		text-align: left;
		width: 100%;
	}

	p,
	strong {
		color: ${tokens.color_gray_dark};
	}
`;

export const SuccessText = styled.strong`
	text-align: center;
	margin-bottom: 20px;
`;
